import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployerRoutingModule } from './employer-routing.module';
import { EmployerModuleComponent } from './employer.module.component';
import { EMPLibraryPaymentComponent, EmployerLibraryModule, MaterialLibraryModule } from 'epay-library';
import { HelperLibraryModule } from 'epay-library';
import { CommonLibraryModule } from 'epay-library';
import { BaseLayoutModule } from '../layout/base-layout.module';
import { EMPHomeComponent } from './components/home/home.component';

import { EMPRegisterComponent } from './components/register/employer.register.component';
import { EMPACHDLandingComponent } from './components/achd/landing/achd.landing.component';
import { EMPCreditCardLandingComponent } from './components/creditcard/landing/creditcard.landing.component';
import { EMPCreditCardPaymentComponent } from './components/creditcard/payment/creditcard.payment.component';
import { EMPEFTCreateFileComponent } from './components/eft/createfile/createfile.component';
import { EMPEFTInformationComponent } from './components/eft/information/eft-information.component';
import { EMPEFTLandingComponent } from './components/eft/landing/eft.landing.component';
import { EMPProfileComponent } from './components/profile/profile.component';
import { EMPACHDInformationComponent } from './components/achd/information/achd-information.component';
import { EMPPaymentComponent } from './components/achd/payment/payment.component';
import { EMPPaymentAccountListComponent } from './components/achd/paymentaccount/paymentaccountlist.component';
import { EMPSecondaryRegistrationComponent } from './components/register/secondary-registration/secondary-registration.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { MaskDataPipe } from 'epay-library';
import { EmployerPaymentAccountListComponent } from './components/achd/paymentaccount/employer-payment-account-list/employer-payment-account-list.component';
import { EmployerPaymentAccountComponent } from './components/achd/paymentaccount/employer-payment-account-list/employer-payment-account/employer-payment-account.component';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { ngxInputRegulateModule } from 'ngx-input-regulate';
import { RouterModule } from '@angular/router';
import { EpayEmployerPaymentComponent } from './components/achd/payment/epay-employer-payment/epay-employer-payment.component';
import { EpayCommonEmployerRegisterComponent } from './components/register/epay-common-employer-register/epay-common-employer-register.component';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatDividerModule} from '@angular/material/divider';


@NgModule({
  declarations: [
    EmployerModuleComponent,
    EMPHomeComponent,
    EMPRegisterComponent,
    EMPACHDLandingComponent,
    EMPEFTLandingComponent,
    EMPProfileComponent,
    EMPPaymentComponent,
    EMPPaymentAccountListComponent,
    EMPSecondaryRegistrationComponent,
    EMPACHDInformationComponent,
    EMPEFTInformationComponent,
    EMPEFTCreateFileComponent,
    EMPCreditCardPaymentComponent,
    EMPCreditCardLandingComponent,
    EmployerPaymentAccountListComponent,
    EmployerPaymentAccountComponent,
    EpayEmployerPaymentComponent,
    EpayCommonEmployerRegisterComponent,
    
  ],
  imports: [
    CommonModule,
    EmployerRoutingModule,
    EmployerLibraryModule,
    HelperLibraryModule,
    CommonLibraryModule,
    BaseLayoutModule,
    MatCardModule,
    RouterModule,
    MaterialLibraryModule,
    AngularMyDatePickerModule,
    MatExpansionModule,
    ngxInputRegulateModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatTooltipModule,
    MatDividerModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [MaskDataPipe],
})
export class EmployerModule {}
